import React from "react";
import Weather from "./Weather";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="St. John's" />
        <footer>
          This project was created by Kateryna Melanych and open-sourced on{" "}
          <a
            href="https://github.com/Katerynkok/react-weather-app"
            target="_blank"
            rel="noreferrer"
          >
            GitHub
          </a>
        </footer>
      </div>
    </div>
  );
}
